var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup14(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#E30F1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2895 16H21.4477V17H12.2895V16ZM21.4477 14H12.2895V13H21.4477V14ZM18.0134 25L19.1492 26H10V10H23.7373V20.5312L23.1649 21.0234L22.5925 20.5234V11H11.1448V25H18.0134ZM23.1649 25.9766L23.1917 26H23.1381L23.1649 25.9766ZM21.4477 19L20.294 20H12.2895V19H21.4477ZM18.6126 22L19.7574 23H12.2895V22H18.6126ZM23.9788 23.5L26 25.2734L25.1951 25.9766L23.1649 24.2109L21.1347 25.9844L20.3298 25.2734L22.36 23.5L20.3298 21.7266L21.1347 21.0234L23.1649 22.7969L25.1951 21.0234L26 21.7344L23.9788 23.5Z",
    fill: "#F8F8F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup14);
export default __webpack_public_path__ + "static/media/Group 1 (4).22f8f1d0e3b4e060924593f08c91ec4e.svg";
export { ForwardRef as ReactComponent };